import React from 'react';
import { Users, Trophy, BarChart3 } from 'lucide-react';
import { useCustomers } from '../../hooks/useCustomers';
import { usePoints } from '../../hooks/usePoints';
import LoadingSpinner from '../common/LoadingSpinner';
import TrialBanner from '../common/TrialBanner';
import CompanyRewardsOverview from './CompanyRewardsOverview';
import BirthdayCustomers from './BirthdayCustomers';
import ConsumptionPatternsChart from './ConsumptionPatternsChart';
import CompanySetupTips from './CompanySetupTips';

const CompanyDashboard = () => {
  const { customers, loading: customersLoading } = useCustomers();
  const { loading: pointsLoading } = usePoints();

  if (customersLoading || pointsLoading) {
    return <LoadingSpinner size="lg" className="py-20" />;
  }

  const stats = {
    totalCustomers: customers.length,
    totalPoints: customers.reduce((sum, c) => sum + c.points, 0),
    avgPoints: customers.length > 0 ? Math.round(customers.reduce((sum, c) => sum + c.points, 0) / customers.length) : 0
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Dashboard da Empresa</h2>
      
      {/* Banner de Trial */}
      <TrialBanner />
      
      {/* Dicas de Configuração */}
      <CompanySetupTips />
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-xl p-6 shadow-sm border">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total de Clientes</p>
              <p className="text-2xl font-bold text-gray-800">{stats.totalCustomers}</p>
            </div>
            <Users className="w-8 h-8 text-blue-600" />
          </div>
        </div>
        
        <div className="bg-white rounded-xl p-6 shadow-sm border">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total de Pontos</p>
              <p className="text-2xl font-bold text-gray-800">{stats.totalPoints}</p>
            </div>
            <Trophy className="w-8 h-8 text-yellow-600" />
          </div>
        </div>
        
        <div className="bg-white rounded-xl p-6 shadow-sm border">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Média de Pontos</p>
              <p className="text-2xl font-bold text-gray-800">{stats.avgPoints}</p>
            </div>
            <BarChart3 className="w-8 h-8 text-green-600" />
          </div>
        </div>
      </div>

      {/* Seção de Prêmios e Resgates */}
      <CompanyRewardsOverview />

      {/* Análise de Padrões de Consumo */}
      <ConsumptionPatternsChart />

      {/* Aniversariantes do Mês */}
      <BirthdayCustomers />

      <div className="bg-white rounded-xl p-6 shadow-sm border">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Clientes com Mais Pontos</h3>
        <div className="space-y-3">
          {customers
            .sort((a, b) => b.points - a.points)
            .slice(0, 5)
            .map(customer => (
              <div key={customer.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium text-gray-800">{customer.name}</p>
                  <p className="text-sm text-gray-600">{customer.cpf}</p>
                </div>
                <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium">
                  {customer.points} pts
                </span>
              </div>
            ))}
          {customers.length === 0 && (
            <p className="text-gray-500 text-center py-4">Nenhum cliente cadastrado ainda</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyDashboard;